import {
   getRequest,
   postRequest,
} from "@/utils/api";

// 查询充电站列表
export function listStation(params) {
   return postRequest('/api/coo/station/list', params)
}

// 查询充电站详情
export function getStation(id) {
   return postRequest('/api/coo/station/get', { id })
}

// 新增充电站
export function addStation(data) {
   return postRequest('/api/coo/station/add', data)
}

// 修改充电站
export function updateStation(data) {
   return postRequest('/api/coo/station/update', data)
}

// 删除充电站
export function delStation(id) {
   return postRequest('/api/coo/station/delete', { id })
}

// 推送充电站
export function pushStation(id) {
   return postRequest('/api/coo/station/push', { id })
}

// 批量推送充电站
export function batchPushStation(data) {
   return postRequest('/api/coo/station/batchPush', data)
}

// 导入充电站
export function importStation(data) {
   return postRequest('/api/coo/station/import', data)
}

// 导出充电站
export function exportStation(params) {
   return getRequest('/api/coo/station/export', params)
}

// 下载导入模板
export function downloadStationTemplate() {
   return getRequest('/api/coo/template/station/template')
}
